import { render, staticRenderFns } from "./DataMapping.vue?vue&type=template&id=327080a4&scoped=true&"
import script from "./DataMapping.vue?vue&type=script&lang=js&"
export * from "./DataMapping.vue?vue&type=script&lang=js&"
import style0 from "./DataMapping.vue?vue&type=style&index=0&id=327080a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327080a4",
  null
  
)

export default component.exports